"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledContainer = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));
var _Modal = _interopRequireDefault(require("@airasia/phoenix-components/components/Modal"));
var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));
var _Title = _interopRequireDefault(require("@airasia/phoenix-components/components/Title"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));
var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));
var _Price = _interopRequireDefault(require("@airasia/phoenix-components/components/Price"));
var _CouponBox = _interopRequireDefault(require("@airasia/phoenix-components/components/CouponBox"));
var _BottomSheet = _interopRequireDefault(require("@airasia/phoenix-components/components/BottomSheet"));
var _Date = _interopRequireDefault(require("@airasia/phoenix-components/components/Date"));
var _Rating = _interopRequireDefault(require("@airasia/phoenix-components/components/Rating"));
var _constant = require("@airasia/phoenix-components/components/Date/constant");
var _Tag = _interopRequireDefault(require("@airasia/phoenix-components/components/Tag"));
var _constant2 = require("@airasia/phoenix-components/components/Tag/constant");
var _CardTimer = _interopRequireDefault(require("../CardTimer"));
var _constant3 = require("../constant");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant4 = require("../CardTimer/constant");
var _cardTimer = require("../CardTimer/cardTimer.util");
var _ImageCarousel = _interopRequireDefault(require("@airasia/phoenix-components/components/ImageCarousel"));
var _utils = require("./utils");
var _constant5 = require("./constant");
var _carouselCard = require("./carouselCard.proptypes");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/* eslint-disable radix */
var ContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__ContainerWrapper",
  componentId: "sc-179472w-0"
})(["", ";height:", ";grid-column:", ";-ms-grid-column-span:", ";outline:none !important;border-radius:", ";scroll-snap-align:start;&:focus-within{border:", ";}box-sizing:border-box;", " ", ";"], function (_ref) {
  var columnSpan = _ref.columnSpan;
  return columnSpan && "display: grid";
}, function (_ref2) {
  var columnSpan = _ref2.columnSpan;
  return columnSpan ? "100%" : "fit-content";
}, function (_ref3) {
  var columnSpan = _ref3.columnSpan;
  return "span ".concat(columnSpan, ";");
}, function (_ref4) {
  var columnSpan = _ref4.columnSpan;
  return columnSpan;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.normal;
}, function (_ref6) {
  var theme = _ref6.theme,
    focusEffect = _ref6.focusEffect;
  return focusEffect && "1px solid  ".concat(theme.colors.secondaryDark);
}, function (_ref7) {
  var isIE = _ref7.isIE,
    gridCol = _ref7.gridCol;
  return isIE && (0, _styledComponents.css)(["display:-ms-grid;-ms-grid-column:", ";"], gridCol);
}, function (_ref8) {
  var width = _ref8.width;
  return width && "width: ".concat(width, "\n   ");
});
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__StyledContainer",
  componentId: "sc-179472w-1"
})(["box-shadow:", ";margin:", ";border-radius:", ";box-sizing:border-box;", ";background-color:", ";", " ", ""], function (_ref9) {
  var theme = _ref9.theme,
    hideBorder = _ref9.hideBorder;
  return hideBorder ? "none" : "0px 1px ".concat(theme.space.micro, " rgba(0, 0, 0, 0.16)");
}, function (_ref10) {
  var theme = _ref10.theme,
    isHolidaysCard = _ref10.isHolidaysCard;
  return isHolidaysCard ? theme.space.XSmall : theme.space.tiny;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.micro;
}, function (props) {
  return props.height ? "height: ".concat(props.height) : "min-height: ".concat(props.theme.space.XXLarge);
}, function (_ref12) {
  var theme = _ref12.theme,
    color = _ref12.color;
  return color ? theme.colors[color] : theme.colors.default;
}, function (_ref13) {
  var hoverEffect = _ref13.hoverEffect,
    hideBorder = _ref13.hideBorder;
  return hoverEffect && (0, _styledComponents.css)(["&:hover{box-shadow:", ";}"], function () {
    return hideBorder ? "none" : " 0px 4px 8px rgba(0, 0, 0, 0.12)";
  });
}, function (_ref14) {
  var theme = _ref14.theme,
    isIE = _ref14.isIE,
    cardOffsetWidth = _ref14.cardOffsetWidth,
    cardOffsetHeight = _ref14.cardOffsetHeight;
  return isIE && (0, _styledComponents.css)(["width:calc(", "px - ", ");height:calc(", "px - ", ");"], cardOffsetWidth, theme.space.small, cardOffsetHeight, theme.space.small);
});
exports.StyledContainer = StyledContainer;
var ButtonTopLeftItem = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__ButtonTopLeftItem",
  componentId: "sc-179472w-2"
})(["display:flex;flex-direction:column;align-items:flex-start;width:100%;flex:1 1 100%;"]);
var TopItem = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__TopItem",
  componentId: "sc-179472w-3"
})(["display:flex;flex-direction:column;align-items:flex-end;width:100%;flex:1 1 100%;"]);
var BottomItem = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__BottomItem",
  componentId: "sc-179472w-4"
})(["display:flex;justify-content:center;flex:1 1 100%;margin-top:", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.tiny;
});
var CarouselCardWrapper = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__CarouselCardWrapper",
  componentId: "sc-179472w-5"
})(["cursor:pointer;background-color:", ";outline:0 !important;border-radius:", ";height:100%;display:flex;flex-direction:column;column-gap:", ";position:relative;"], function (_ref16) {
  var color = _ref16.color,
    theme = _ref16.theme;
  return color && theme.colors[color] || theme.colors.default;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.borderRadius.normal;
}, function (_ref18) {
  var theme = _ref18.theme,
    isHolidaysCard = _ref18.isHolidaysCard;
  return isHolidaysCard ? theme.space.standard : '';
});
var StyledCardHeader = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__StyledCardHeader",
  componentId: "sc-179472w-6"
})(["position:relative;border-top-left-radius:", ";border-top-right-radius:", ";overflow:hidden;z-index:0;"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.borderRadius.normal;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.borderRadius.normal;
});
var LabelContainer = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__LabelContainer",
  componentId: "sc-179472w-7"
})(["position:absolute;margin:", ";", ";z-index:1;"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.space.tiny;
}, function (_ref22) {
  var type = _ref22.type;
  return type === 'primary' ? "top: 0px;" : "bottom:0px; right:0px";
});
var StyledCardItem = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__StyledCardItem",
  componentId: "sc-179472w-8"
})(["display:grid;grid-gap:", ";padding:", ";", ""], function (_ref23) {
  var theme = _ref23.theme,
    noGap = _ref23.noGap;
  return !noGap && theme.space.micro;
}, function (_ref24) {
  var theme = _ref24.theme;
  return "".concat(theme.space.small, " ").concat(theme.space.small, " ").concat(theme.space.micro, " ");
}, function (_ref25) {
  var isIE = _ref25.isIE;
  return isIE && (0, _styledComponents.css)(["display:flex;flex-direction:column;p{margin-bottom:4px;}"]);
});
var FooterRow = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__FooterRow",
  componentId: "sc-179472w-9"
})(["display:flex;width:100%;"]);
var StyledcardFooter = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__StyledcardFooter",
  componentId: "sc-179472w-10"
})(function (_ref26) {
  var theme = _ref26.theme;
  return "\n    display: flex;\n    padding: 0px ".concat(theme.space.small, " ").concat(theme.space.small, " ").concat(theme.space.small, ";\n    flex-wrap: wrap;\n    margin-top: ").concat(function (_ref27) {
    var isHolidaysCard = _ref27.isHolidaysCard;
    return !isHolidaysCard && "auto";
  }, ";\n  ");
});
var StyledFooter = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__StyledFooter",
  componentId: "sc-179472w-11"
})(["display:flex;flex-direction:column;width:", ";margin-top:", ";"], function (_ref28) {
  var isHolidaysCard = _ref28.isHolidaysCard;
  return isHolidaysCard ? '100%' : '50%';
}, function (_ref29) {
  var theme = _ref29.theme,
    isHolidaysCard = _ref29.isHolidaysCard;
  return isHolidaysCard ? theme.space.XSmall : '';
}); // padding: 0px ${({ theme }) => theme.space.normal} ${({ theme }) => theme.space.normal} 0px;

var StyledFooterRight = (0, _styledComponents.default)(StyledFooter).withConfig({
  displayName: "CarouselCard__StyledFooterRight",
  componentId: "sc-179472w-12"
})(["flex:1;align-items:flex-end;", " ", " ", ""], function (_ref30) {
  var isHolidaysCard = _ref30.isHolidaysCard;
  return isHolidaysCard && "white-space: nowrap;";
}, function (_ref31) {
  var justify = _ref31.justify;
  return justify && "justify-content: flex-end;\n    min-height: 34px;";
}, function (_ref32) {
  var isIE = _ref32.isIE;
  return isIE && (0, _styledComponents.css)(["& .price-desc{width:100%;}"]);
}); // padding: 0px 0px ${({ theme }) => theme.space.normal} ${({ theme }) => theme.space.normal};

var StyledFooterLeft = (0, _styledComponents.default)(StyledFooter).withConfig({
  displayName: "CarouselCard__StyledFooterLeft",
  componentId: "sc-179472w-13"
})(["align-items:flex-start;", " ", ""], function (_ref33) {
  var flex = _ref33.flex;
  return flex && "flex: 1;";
}, function (_ref34) {
  var justifySelf = _ref34.justifySelf;
  return justifySelf && "justify-self: ".concat(justifySelf);
});
var LastItem = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__LastItem",
  componentId: "sc-179472w-14"
})(["margin-top:", ";margin-bottom:", ";"], function (_ref35) {
  var marginTop = _ref35.marginTop,
    theme = _ref35.theme;
  return marginTop ? theme.space[marginTop] : 'auto';
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.micro;
});
var TimerContainer = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__TimerContainer",
  componentId: "sc-179472w-15"
})(["margin-bottom:", ";"], function (_ref37) {
  var theme = _ref37.theme;
  return theme.space.tiny;
});
var OriginalPriceComponent = _styledComponents.default.span.withConfig({
  displayName: "CarouselCard__OriginalPriceComponent",
  componentId: "sc-179472w-16"
})(["*{font-size:", ";}"], function (_ref38) {
  var theme = _ref38.theme;
  return theme.fontSize.small;
});
var TagContainer = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__TagContainer",
  componentId: "sc-179472w-17"
})(["margin-bottom:2px;"]);
var ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__ImageWrapper",
  componentId: "sc-179472w-18"
})(["display:flex;position:relative;z-index:1;align-items:center;justify-content:center;"]);
var OverlayLabel = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__OverlayLabel",
  componentId: "sc-179472w-19"
})(["position:absolute;z-index:10;max-width:130px;color:white;justify-content:center;text-align:center;font-weight:", ";font-size:", ";line-height:", ";"], function (_ref39) {
  var theme = _ref39.theme;
  return theme.fontWeight.medium;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.fontSize.XSmall;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.lineHeight.small;
});
var AdditionalTag = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__AdditionalTag",
  componentId: "sc-179472w-20"
})(["position:absolute;z-index:11;background-color:", ";padding:1px 4px;font-size:", ";font-weight:", ";color:", ";top:", ";left:", ";border-radius:", ";"], function (_ref42) {
  var theme = _ref42.theme;
  return theme.backgroundColor.redLight;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.fontSize.XSmall;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.fontWeight.medium;
}, function (_ref45) {
  var theme = _ref45.theme,
    additionalTextColor = _ref45.additionalTextColor;
  return !additionalTextColor ? theme.colors.primaryDark : additionalTextColor;
}, function (_ref46) {
  var topPos = _ref46.topPos;
  return !topPos ? '170px' : topPos;
}, function (_ref47) {
  var leftPos = _ref47.leftPos;
  return !leftPos ? '16px' : leftPos;
}, function (_ref48) {
  var theme = _ref48.theme;
  return theme.borderRadius.normal;
});
var OverlayBackground = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__OverlayBackground",
  componentId: "sc-179472w-21"
})(["position:absolute;z-index:1;background-color:", ";opacity:0.5;width:100%;height:100%;"], function (_ref49) {
  var theme = _ref49.theme;
  return theme.backgroundColor.secondary;
});
var CardHeader = function CardHeader(props) {
  var imageUrl = props.imageUrl,
    imageAlt = props.imageAlt,
    lowResolutionImageUrl = props.lowResolutionImageUrl,
    enableProgressiveImageLoading = props.enableProgressiveImageLoading,
    lazyLoadImage = props.lazyLoadImage,
    primaryLabel = props.primaryLabel,
    secondaryLabel = props.secondaryLabel,
    imageHoverAnimation = props.imageHoverAnimation,
    cardHeaderHeight = props.cardHeaderHeight,
    theme = props.theme,
    overlayLabel = props.overlayLabel,
    showOverlayBackGround = props.showOverlayBackGround,
    customCardHeaderHeight = props.customCardHeaderHeight,
    imageList = props.imageList,
    viewPort = props.viewPort;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var minHeight = themeContext.space.XXXLarge;
  var borderRadius = "".concat(themeContext.borderRadius.normal, " ").concat(themeContext.borderRadius.normal, " 0px 0px");
  var getImageHeight = function getImageHeight() {
    var imgHeight;
    if (customCardHeaderHeight) imgHeight = customCardHeaderHeight;else if (cardHeaderHeight) imgHeight = cardHeaderHeight;else imgHeight = minHeight;
    return imgHeight;
  };
  var imageArray = imageList && imageList.split('|');
  return /*#__PURE__*/_react.default.createElement(StyledCardHeader, null, /*#__PURE__*/_react.default.createElement(ImageWrapper, null, overlayLabel && /*#__PURE__*/_react.default.createElement(OverlayLabel, null, overlayLabel), showOverlayBackGround && /*#__PURE__*/_react.default.createElement(OverlayBackground, null, "\xA0"), !imageArray ? /*#__PURE__*/_react.default.createElement(_Image.default, {
    centerFocus: viewPort !== 'tablet',
    lowResolutionImageUrl: lowResolutionImageUrl,
    enableProgressiveImageLoading: enableProgressiveImageLoading,
    hoverAnimation: imageHoverAnimation,
    src: imageUrl,
    alt: imageAlt,
    lazyLoadImage: lazyLoadImage,
    height: getImageHeight,
    width: _constant5.TOKENS.DEFAULT_IMAGE_WIDTH,
    radius: borderRadius,
    theme: theme,
    accessible: false
  }) : /*#__PURE__*/_react.default.createElement(_ImageCarousel.default, {
    responsive: [{
      breakPoint: 0,
      cardsToShow: 1
    }],
    infinite: true,
    showDots: false
  }, imageArray.map(function (image) {
    return /*#__PURE__*/_react.default.createElement(_Image.default, {
      key: image,
      src: image,
      width: _constant5.TOKENS.DEFAULT_IMAGE_WIDTH,
      height: getImageHeight,
      placeHolderBackground: "default"
    });
  }))), primaryLabel && /*#__PURE__*/_react.default.createElement(LabelContainer, {
    type: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    type: _constant5.TOKENS.PRIMARY_LABEL.TYPE,
    theme: theme,
    accessible: false
  }, primaryLabel)), secondaryLabel && /*#__PURE__*/_react.default.createElement(LabelContainer, {
    type: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    type: _constant5.TOKENS.SECONDARY_LABEL.TYPE,
    theme: theme,
    accessible: false
  }, secondaryLabel)));
};
var InlineDiv = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__InlineDiv",
  componentId: "sc-179472w-22"
})(["display:inline;"]);
var ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__ModalContainer",
  componentId: "sc-179472w-23"
})(["margin:", ";display:flex;flex-direction:column;align-items:center;"], function (_ref50) {
  var forMobile = _ref50.forMobile;
  return forMobile ? "80px 40px 40px 40px" : "0px 20px";
});
var UnorderedList = _styledComponents.default.ul.withConfig({
  displayName: "CarouselCard__UnorderedList",
  componentId: "sc-179472w-24"
})(["list-style-type:", ";padding:", ";"], function (_ref51) {
  var type = _ref51.type;
  return type || "square";
}, function (_ref52) {
  var type = _ref52.type;
  return type === 'none' && '0px';
});
var ListElement = _styledComponents.default.li.withConfig({
  displayName: "CarouselCard__ListElement",
  componentId: "sc-179472w-25"
})(["margin:10px 0px;margin-left:", ";"], function (_ref53) {
  var removeIndentation = _ref53.removeIndentation,
    theme = _ref53.theme;
  return removeIndentation && "-".concat(theme.space.standard);
});
var CouponBoxContainer = _styledComponents.default.div.withConfig({
  displayName: "CarouselCard__CouponBoxContainer",
  componentId: "sc-179472w-26"
})(["display:flex;width:100%;justify-content:", ";"], function (_ref54) {
  var couponBoxAlignment = _ref54.couponBoxAlignment;
  return couponBoxAlignment || "center";
});
var renderText = function renderText(type) {
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'neutral';
  var strikethrough = arguments.length > 2 ? arguments[2] : undefined;
  var dir = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ltr';
  var theme = arguments.length > 4 ? arguments[4] : undefined;
  var text = arguments.length > 5 ? arguments[5] : undefined;
  var customProperties = arguments.length > 6 ? arguments[6] : undefined;
  return text && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: false,
    direction: dir,
    strikethrough: strikethrough,
    type: type,
    color: color,
    theme: theme,
    customProperties: customProperties
  }, text);
};
var PromotionSubtitle = function PromotionSubtitle(props) {
  var textType = props.textType,
    color = props.color,
    textDir = props.textDir,
    theme = props.theme,
    text = props.text,
    isMobile = props.isMobile,
    promotionTnC = props.promotionTnC,
    promotionCouponCode = props.promotionCouponCode,
    couponBoxAlignment = props.couponBoxAlignment,
    couponBoxLabel = props.couponBoxLabel,
    couponBoxCtaText = props.couponBoxCtaText,
    couponBoxCtaHref = props.couponBoxCtaHref,
    subtitleExpandCtaText = props.subtitleExpandCtaText,
    updateGtmId = props.updateGtmId,
    promotionTnCListType = props.promotionTnCListType,
    removeIndentation = props.removeIndentation;
  var textSliceLimit = 100;
  var promotionTncArray = promotionTnC.split('|');
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    openModal = _useState2[0],
    setOpenModal = _useState2[1];
  var handleKnowMoreClick = function handleKnowMoreClick(e) {
    setOpenModal(true);
    e.preventDefault();
  };
  var handleModalClose = function handleModalClose(e) {
    setOpenModal(false);
    e.preventDefault();
  };
  var renderExpandedContent = function renderExpandedContent(forMobile) {
    return /*#__PURE__*/_react.default.createElement(ModalContainer, {
      forMobile: forMobile
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      textAlign: "justify"
    }, text), /*#__PURE__*/_react.default.createElement(UnorderedList, {
      type: promotionTnCListType
    }, promotionTnC && promotionTncArray.map(function (value) {
      var temtext = value.split('&lt;').join('<');
      var newtext = temtext.split('&gt;').join('>');
      return /*#__PURE__*/_react.default.createElement(ListElement, {
        key: value,
        removeIndentation: removeIndentation
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: "sub",
        color: "greyDark",
        textAlign: "justify"
      }, /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: newtext
        }
      })));
    })), promotionCouponCode && /*#__PURE__*/_react.default.createElement(CouponBoxContainer, {
      couponBoxAlignment: couponBoxAlignment
    }, /*#__PURE__*/_react.default.createElement(_CouponBox.default, {
      couponCode: promotionCouponCode,
      labelText: couponBoxLabel,
      ctaLinkText: couponBoxCtaText,
      updateGtmId: updateGtmId,
      ctaLinkHref: couponBoxCtaHref
    })));
  };
  var expandCtaProps = {
    size: 'XSmall',
    callback: handleKnowMoreClick,
    // eslint-disable-next-line no-script-url
    href: 'javascript:void(0);',
    target: 'callback'
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(InlineDiv, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    direction: textDir,
    type: textType,
    color: color,
    theme: theme,
    display: "inline",
    textLimit: textSliceLimit
  }, text), text.length <= textSliceLimit && /*#__PURE__*/_react.default.createElement(_Text.default, null, "..."), /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({}, expandCtaProps, {
    linkname: "subtitleExpandCta",
    updateGtmId: updateGtmId
  }), subtitleExpandCtaText)), isMobile ? /*#__PURE__*/_react.default.createElement(_BottomSheet.default, {
    height: "70%",
    show: openModal,
    theme: theme,
    onClose: handleModalClose,
    showCloseBtn: true,
    showOverlay: true,
    zIndex: _constant5.BOTTOM_SHEET_INDEX
  }, renderExpandedContent(isMobile)) : /*#__PURE__*/_react.default.createElement(_Modal.default, {
    openModal: openModal,
    onClose: handleModalClose,
    theme: theme,
    width: "564px"
  }, renderExpandedContent(isMobile)));
};
var CardBody = function CardBody(props) {
  var timerDetails = props.timerDetails,
    attractText = props.attractText,
    title = props.title,
    subTitle = props.subTitle,
    stars = props.stars,
    theme = props.theme,
    isIE = props.isIE,
    timerEndHandler = props.timerEndHandler,
    allowLocaleFormat = props.allowLocaleFormat,
    locale = props.locale,
    localeConfig = props.localeConfig,
    isMobile = props.isMobile,
    promotionTnC = props.promotionTnC,
    promotionCouponCode = props.promotionCouponCode,
    couponBoxAlignment = props.couponBoxAlignment,
    promotionTnCListType = props.promotionTnCListType,
    couponBoxLabel = props.couponBoxLabel,
    couponBoxCtaText = props.couponBoxCtaText,
    couponBoxCtaHref = props.couponBoxCtaHref,
    subtitleExpandCtaText = props.subtitleExpandCtaText,
    tags = props.tags,
    updateGtmId = props.updateGtmId,
    isHolidaysCard = props.isHolidaysCard,
    customSubTitleMobileSize = props.customSubTitleMobileSize,
    customTitleMobileSize = props.customTitleMobileSize,
    viewPort = props.viewPort,
    removeIndentation = props.removeIndentation;
  var renderSubtitle = function renderSubtitle() {
    if (subTitle instanceof Date) {
      return /*#__PURE__*/_react.default.createElement(_Date.default, {
        date: subTitle,
        format: _constant.DATE_FORMATS['Simple Day'],
        theme: theme,
        allowLocaleFormat: allowLocaleFormat,
        locale: locale,
        localeConfig: localeConfig && localeConfig.date,
        accessible: false
      });
    }
    if (subtitleExpandCtaText) {
      return /*#__PURE__*/_react.default.createElement(PromotionSubtitle, {
        textType: _constant5.TOKENS.SUBTITLE.SIZE,
        color: _constant5.TOKENS.SUBTITLE.COLOR,
        textDir: "ltr",
        theme: theme,
        text: subTitle,
        isMobile: isMobile,
        promotionTnC: promotionTnC,
        promotionCouponCode: promotionCouponCode,
        couponBoxAlignment: couponBoxAlignment,
        couponBoxLabel: couponBoxLabel,
        couponBoxCtaText: couponBoxCtaText,
        couponBoxCtaHref: couponBoxCtaHref,
        subtitleExpandCtaText: subtitleExpandCtaText,
        updateGtmId: updateGtmId,
        promotionTnCListType: promotionTnCListType,
        removeIndentation: removeIndentation
      });
    } // eslint-disable-next-line max-len

    return renderText(_constant5.TOKENS.SUBTITLE.SIZE, _constant5.TOKENS.SUBTITLE.COLOR, false, 'ltr', theme, subTitle, {
      fontSize: viewPort === 'mobile' && customSubTitleMobileSize
    });
  };
  var renderTag = function renderTag() {
    if (tags) {
      return /*#__PURE__*/_react.default.createElement(TagContainer, null, tags &&
      // eslint-disable-next-line react/prop-types
      tags.map(function (tag, index) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
          key: tag.label
        }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
          href: tag.url,
          target: tag.tagTarget || 'self',
          color: tag.color,
          backgroundColor: tag.backgroundColor,
          padding: tag.padding,
          margin: tag.margin,
          type: tag.type ? tag.type : _constant2.TEXT_TYPE.small.type,
          handleOnClick: tag.handleOnClick ? function () {
            tag.handleOnClick(tag, index);
          } : null
        }, tag.label));
      }));
    }
    return null;
  };
  return /*#__PURE__*/_react.default.createElement(StyledCardItem, {
    isIE: isIE
  }, timerDetails.timerStartDateTime && timerDetails.timerEndDateTime && /*#__PURE__*/_react.default.createElement(TimerContainer, null, /*#__PURE__*/_react.default.createElement(_CardTimer.default, {
    timerDetails: timerDetails,
    theme: theme,
    timeEndCallback: timerEndHandler,
    allowLocaleFormat: allowLocaleFormat,
    locale: locale,
    localeConfig: localeConfig,
    accessible: false
  })), tags && renderTag(), attractText && renderText(_constant5.TOKENS.ATTRACT_TEXT.SIZE, _constant5.TOKENS.ATTRACT_TEXT.COLOR, false, 'ltr', theme, attractText), title && renderText(isHolidaysCard ? _constant5.TOKENS.TITLE.SIZE_HOLIDAY : _constant5.TOKENS.TITLE.SIZE, _constant5.TOKENS.TITLE.COLOR, false, 'ltr', theme, title, {
    fontSize: viewPort === 'mobile' && customTitleMobileSize
  }), subTitle && renderSubtitle(), stars && /*#__PURE__*/_react.default.createElement(_Rating.default, {
    accessible: false,
    maxRate: 5,
    rate: parseInt(stars, 10),
    starColor: _constant5.TOKENS.STARS.COLOR,
    starSize: _constant5.TOKENS.STARS.STAR_SIZE,
    theme: theme,
    type: _constant5.TOKENS.STARS.TYPE
  }));
};
var CardFooter = function CardFooter(props) {
  var location = props.location,
    rating = props.rating,
    cta = props.cta,
    ctaConfig = props.ctaConfig,
    priceDisclaimer = props.priceDisclaimer,
    discount = props.discount,
    originalPrice = props.originalPrice,
    price = props.price,
    pricePrefix = props.pricePrefix,
    priceClarification = props.priceClarification,
    url = props.url,
    queryParams = props.queryParams,
    newTab = props.newTab,
    currencyCode = props.currencyCode,
    theme = props.theme,
    isIE = props.isIE,
    productType = props.productType,
    color = props.color,
    hoverColor = props.hoverColor,
    backgroundColor = props.backgroundColor,
    hoverBackgroundColor = props.hoverBackgroundColor,
    width = props.width,
    customProperties = props.customProperties,
    handleClickOnButton = props.handleClickOnButton,
    cardIndex = props.cardIndex,
    showFormattedPrice = props.showFormattedPrice,
    formattedPrice = props.formattedPrice,
    formattedOriginalPrice = props.formattedOriginalPrice,
    allowLocaleFormat = props.allowLocaleFormat,
    locale = props.locale,
    isMobile = props.isMobile,
    decimalType = props.decimalType,
    updateGtmId = props.updateGtmId,
    fireGtmHandle = props.fireGtmHandle,
    gaID = props.gaID,
    isHolidaysCard = props.isHolidaysCard;
  var renderOriginalPrice = function renderOriginalPrice() {
    /* ------- Strikethrough price ---- */
    var priceText = showFormattedPrice ? formattedOriginalPrice : originalPrice && "".concat(currencyCode, " ").concat(originalPrice) || null;
    if (priceText && !allowLocaleFormat) {
      return renderText(_constant5.TOKENS.ORIGINAL_PRICE.SIZE, _constant5.TOKENS.ORIGINAL_PRICE.COLOR, true, 'ltr', theme, priceText, {
        key: 'originalPrice'
      });
    }
    if (priceText && allowLocaleFormat) {
      return /*#__PURE__*/_react.default.createElement(OriginalPriceComponent, null, /*#__PURE__*/_react.default.createElement(_Price.default, {
        amount: Number(originalPrice),
        color: _constant5.TOKENS.ORIGINAL_PRICE.COLOR,
        allowLocaleFormat: allowLocaleFormat,
        locale: locale,
        currency: currencyCode,
        currencyDisplay: isMobile ? 'symbol' : 'code',
        key: "original-price",
        strikethrough: true,
        decimalType: decimalType
      }));
    }
    return null;
  };
  var renderPrice = function renderPrice() {
    /* --------- price ----------------- */
    if (showFormattedPrice && !allowLocaleFormat) {
      if (formattedPrice) {
        return /*#__PURE__*/_react.default.createElement(_Title.default, {
          accessible: false,
          type: "h2",
          theme: theme,
          key: "price"
        }, formattedPrice);
      }
      return null;
    }
    if (price && /^\d+(\.\d+)?$/.test(price)) {
      return /*#__PURE__*/_react.default.createElement(_Price.default, {
        amount: Number(price),
        color: _constant5.TOKENS.PRICE.COLOR,
        currency: currencyCode,
        currencyDisplay: isMobile ? 'symbol' : 'code',
        theme: theme,
        key: "price",
        accessible: false,
        allowLocaleFormat: allowLocaleFormat,
        locale: locale,
        decimalType: decimalType,
        pricePrefix: pricePrefix
      });
    }
    return null;
  };
  var handleClickStopProppagation = function handleClickStopProppagation(e) {
    fireGtmHandle();
    e.stopPropagation();
  };
  var renderLink = function renderLink() {
    return cta && /*#__PURE__*/_react.default.createElement(LastItem, {
      onClick: handleClickStopProppagation
    },
    // eslint-disable-next-line react/prop-types
    newTab && newTab.toUpperCase() === 'TRUE' ? /*#__PURE__*/_react.default.createElement(_Link.default, {
      customProperties: {
        id: 'cta_link'
      } // eslint-disable-next-line react/prop-types
      ,

      target: (ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.target) || _constant5.TOKENS.CTA.TARGET_TYPE.TAB // eslint-disable-next-line react/prop-types
      ,

      hoverUnderlined: false // eslint-disable-next-line react/prop-types
      ,

      href: (ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.href) || url // eslint-disable-next-line react/prop-types
      ,

      queryParams: (ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.queryParams) || queryParams // eslint-disable-next-line react/prop-types
      ,

      color: (ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.color) || _constant5.TOKENS.CTA.COLOR,
      theme: theme,
      accessible: false,
      linkname: "cta-link",
      updateGtmId: updateGtmId // eslint-disable-next-line react/prop-types
      ,

      callback: ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.callback // eslint-disable-next-line react/prop-types
      ,

      type: ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.type // eslint-disable-next-line react/prop-types
      ,

      size: ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.size,
      gaID: gaID
    }, cta) : /*#__PURE__*/_react.default.createElement(_Link.default // eslint-disable-next-line react/prop-types
    , {
      target: (ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.target) || _constant5.TOKENS.CTA.TARGET_TYPE.PARENT,
      hoverUnderlined: false // eslint-disable-next-line react/prop-types
      ,

      href: (ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.href) || url // eslint-disable-next-line react/prop-types
      ,

      queryParams: (ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.queryParams) || queryParams // eslint-disable-next-line react/prop-types
      ,

      color: (ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.color) || _constant5.TOKENS.CTA.COLOR,
      theme: theme,
      accessible: false,
      linkname: "cta-link",
      updateGtmId: updateGtmId // eslint-disable-next-line react/prop-types
      ,

      callback: ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.callback // eslint-disable-next-line react/prop-types
      ,

      type: ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.type // eslint-disable-next-line react/prop-types
      ,

      size: ctaConfig === null || ctaConfig === void 0 ? void 0 : ctaConfig.size,
      gaID: gaID
    }, cta));
  };
  var renderLocationAndRating = function renderLocationAndRating() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, location && /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant5.TOKENS.LOCATION.SIZE,
      color: _constant5.TOKENS.LOCATION.COLOR,
      theme: theme,
      accessible: false,
      verticalAlign: _constant5.TOKENS.LOCATION.VALIGN
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: _constant5.TOKENS.LOCATION.ICON,
      color: _constant5.TOKENS.LOCATION.ICON_COLOR,
      theme: theme,
      accessible: false,
      padding: _constant5.TOKENS.LOCATION.PADDING
    }), location), rating && /*#__PURE__*/_react.default.createElement(LastItem, {
      marginTop: "micro"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: _constant5.TOKENS.RATING.COLOR,
      theme: theme,
      accessible: false
    }, rating)));
  };
  var renderPriceDetails = function renderPriceDetails(isHolidayCard) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, discount && isHolidayCard ? /*#__PURE__*/_react.default.createElement(_Label.default, {
      labelColor: "tertiaryLight",
      textColor: "tertiaryDark"
    }, renderText(_constant5.TOKENS.DISCOUNT.SIZE, _constant5.TOKENS.DISCOUNT.COLOR, false, 'ltr', theme, discount)) : renderText(_constant5.TOKENS.DISCOUNT.SIZE, _constant5.TOKENS.DISCOUNT.COLOR, false, 'ltr', theme, discount), renderOriginalPrice(), priceDisclaimer && renderText(_constant5.TOKENS.PRICE_DISCLAIMER.SIZE, _constant5.TOKENS.PRICE_DISCLAIMER.COLOR, false, 'ltr', theme, priceDisclaimer));
  };
  var renderPriceClarification = function renderPriceClarification() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, priceClarification && renderText(_constant5.TOKENS.PRICE_CLARIFICATION.SIZE, _constant5.TOKENS.PRICE_CLARIFICATION.COLOR, false, '', theme, priceClarification, {
      className: 'price-desc'
    }));
  };
  var renderCardFooter = function renderCardFooter() {
    if (showFormattedPrice) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (location || rating || priceDisclaimer || discount || formattedOriginalPrice) && /*#__PURE__*/_react.default.createElement(FooterRow, null, (location || rating) && /*#__PURE__*/_react.default.createElement(StyledFooterLeft, {
        isHolidaysCard: isHolidaysCard
      }, renderLocationAndRating()), (priceDisclaimer || discount || formattedOriginalPrice) && /*#__PURE__*/_react.default.createElement(StyledFooterRight, {
        isIE: isIE,
        justify: true
      }, renderPriceDetails(isHolidaysCard))), (formattedPrice || priceClarification || cta) && /*#__PURE__*/_react.default.createElement(FooterRow, null, /*#__PURE__*/_react.default.createElement(StyledFooterRight, {
        isIE: isIE
      }, renderPrice(), (cta || priceClarification) && /*#__PURE__*/_react.default.createElement(FooterRow, null, cta && /*#__PURE__*/_react.default.createElement(StyledFooterLeft, {
        flex: true
      }, renderLink()), priceClarification && /*#__PURE__*/_react.default.createElement(StyledFooterRight, null, renderPriceClarification())))));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (location || rating || cta) && /*#__PURE__*/_react.default.createElement(StyledFooterLeft, {
      isHolidaysCard: isHolidaysCard
    }, (location || rating) && renderLocationAndRating(), cta && renderLink()), (priceDisclaimer || discount || originalPrice || price || priceClarification) && /*#__PURE__*/_react.default.createElement(StyledFooterRight, {
      isIE: isIE,
      isHolidaysCard: isHolidaysCard
    }, renderPriceDetails(isHolidaysCard), renderPrice(), renderPriceClarification()));
  };
  return /*#__PURE__*/_react.default.createElement(StyledcardFooter, {
    isHolidaysCard: isHolidaysCard
  }, productType && productType === _constant5.PRODUCT_TYPE.BUTTON ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ButtonTopLeftItem, null, renderLocationAndRating()), /*#__PURE__*/_react.default.createElement(TopItem, null, renderPriceDetails(), renderPrice(), renderPriceClarification()), productType && /*#__PURE__*/_react.default.createElement(BottomItem, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    buttonType: "button",
    color: color,
    hoverColor: hoverColor,
    backgroundColor: backgroundColor,
    hoverBackgroundColor: hoverBackgroundColor,
    width: width,
    customProperties: customProperties,
    theme: theme,
    handleClick: handleClickOnButton,
    cardIndex: cardIndex,
    accessible: false,
    buttonName: "cta-button",
    updateGtmId: updateGtmId
  }, cta))) : renderCardFooter());
};
var CarouselCard = function CarouselCard(props) {
  var index = props.index,
    data = props.data,
    queryParams = props.queryParams,
    theme = props.theme,
    accessible = props.accessible,
    customProperties = props.customProperties,
    width = props.width,
    hoverEffect = props.hoverEffect,
    focusEffect = props.focusEffect,
    imageHoverAnimation = props.imageHoverAnimation,
    handleClick = props.handleClick,
    handleClickOnButton = props.handleClickOnButton,
    fireGtm = props.fireGtm,
    cardHeaderHeight = props.cardHeaderHeight,
    color = props.color,
    columnSpan = props.columnSpan,
    isIE = props.isIE,
    productType = props.productType,
    showFormattedPrice = props.showFormattedPrice,
    cardWidth = props.cardWidth,
    chinaDisclaimerListener = props.chinaDisclaimerListener,
    allowLocaleFormat = props.allowLocaleFormat,
    locale = props.locale,
    localeConfig = props.localeConfig,
    isCnDomain = props.isCnDomain,
    isHideFooter = props.isHideFooter,
    isMobile = props.isMobile,
    handleCardVisibility = props.handleCardVisibility,
    idConfig = props.idConfig,
    environment = props.environment,
    enableProgressiveImageLoading = props.enableProgressiveImageLoading,
    lazyLoadImage = props.lazyLoadImage,
    gtmEventData = props.gtmEventData,
    onMouseEnterEvent = props.onMouseEnterEvent,
    decimalType = props.decimalType,
    hideBorder = props.hideBorder,
    gaID = props.gaID,
    customCardHeaderHeight = props.customCardHeaderHeight,
    isHolidaysCard = props.isHolidaysCard,
    viewPort = props.viewPort,
    removeIndentation = props.removeIndentation;
  var _ref55 = idConfig || {},
    widgetName = _ref55.widgetName,
    parentName = _ref55.parentName;
  var _useState3 = (0, _react.useState)('carouselCard'),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    dynamicID = _useState4[0],
    setId = _useState4[1];
  (0, _react.useEffect)(function () {
    var url = 'carouselCard';
    if (parentName) {
      url = "".concat(parentName, "-carouselCard");
    }
    if (index) {
      url += "-".concat(index);
    }
    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }
    setId(url);
  }, [widgetName, parentName, index]);
  var _ref56 = data || {},
    cta = _ref56.cta,
    url = _ref56.url,
    image = _ref56.image,
    imageAlt = _ref56.imageAlt,
    primaryLabel = _ref56.primaryLabel,
    secondaryLabel = _ref56.secondaryLabel,
    attractText = _ref56.attractText,
    title = _ref56.title,
    subtitle = _ref56.subtitle,
    star = _ref56.star,
    productID = _ref56.productID,
    location = _ref56.location,
    rating = _ref56.rating,
    priceDisclaimer = _ref56.priceDisclaimer,
    discount = _ref56.discount,
    originalprice = _ref56.originalprice,
    price = _ref56.price,
    pricePrefix = _ref56.pricePrefix,
    priceClarification = _ref56.priceClarification,
    newTab = _ref56.newTab,
    colorButton = _ref56.colorButton,
    hoverColor = _ref56.hoverColor,
    backgroundColor = _ref56.backgroundColor,
    hoverBackgroundColor = _ref56.hoverBackgroundColor,
    widthButton = _ref56.widthButton,
    customPropertiesButton = _ref56.customPropertiesButton,
    currencyCode = _ref56.currencyCode,
    timerEndDateTime = _ref56.timerEndDateTime,
    timerLabelEndDays = _ref56.timerLabelEndDays,
    timerLabelEndHours = _ref56.timerLabelEndHours,
    timerLabelStartDays = _ref56.timerLabelStartDays,
    timerLabelStartHours = _ref56.timerLabelStartHours,
    timerStartDateTime = _ref56.timerStartDateTime,
    timerTimeZone = _ref56.timerTimeZone,
    formattedPrice = _ref56.formattedPrice,
    formattedOriginalPrice = _ref56.formattedOriginalPrice,
    cnDisclaimerLine1 = _ref56.cnDisclaimerLine1,
    cndisclaimerLine1 = _ref56.cndisclaimerLine1,
    promotionTnC = _ref56.promotionTnC,
    promotionCouponCode = _ref56.promotionCouponCode,
    couponBoxAlignment = _ref56.couponBoxAlignment,
    promotionTnCListType = _ref56.promotionTnCListType,
    couponBoxLabel = _ref56.couponBoxLabel,
    couponBoxCtaText = _ref56.couponBoxCtaText,
    couponBoxCtaHref = _ref56.couponBoxCtaHref,
    subtitleExpandCtaText = _ref56.subtitleExpandCtaText,
    tags = _ref56.tags,
    lowResolutionImageUrl = _ref56.lowResolutionImageUrl,
    ctaConfig = _ref56.ctaConfig,
    additionalText = _ref56.additionalText,
    additionalTextColor = _ref56.additionalTextColor,
    leftPos = _ref56.leftPos,
    topPos = _ref56.topPos,
    overlayLabel = _ref56.overlayLabel,
    showOverlayBackGround = _ref56.showOverlayBackGround,
    imageList = _ref56.imageList,
    customTitleMobileSize = _ref56.customTitleMobileSize,
    customSubTitleMobileSize = _ref56.customSubTitleMobileSize;
  var gtmid = 'carouselcard';
  var setGtmId = function setGtmId(value) {
    gtmid = value;
  };
  function fireGtmHandler() {
    var gtmEvent = gtmEventData ? gtmEventData.replace('{{cardtitle}}', title || null).replace('{{cardposition}}', parseInt(index) + 1 || null).replace('{{buttonClick}}', gtmid || null) : null; // eslint-disable-next-line no-unused-expressions

    fireGtm ? fireGtm(gtmEvent, true) : null;
  }
  var containerWrapperRef = (0, _react.useRef)(null);
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    cardOffsetWidth = _useState6[0],
    setCardOffsetWidth = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    cardOffsetHeight = _useState8[0],
    setCardOffsetHeight = _useState8[1];
  var checkPropsForPromo = function checkPropsForPromo() {
    if (!timerStartDateTime) {
      return false;
    }
    var timeZone = timerTimeZone && timerTimeZone.length > 0 ? timerTimeZone : _constant4.DEFAULT_TIMEZONE;
    var dateNow = (0, _cardTimer.convertDateToTimeZone)(new Date(), timeZone);
    var checkedTimerEndDateTime = (0, _cardTimer.checkDateTimeFormat)(timerEndDateTime);
    var endDate = new Date(checkedTimerEndDateTime);
    return dateNow > endDate;
  };
  var _useState9 = (0, _react.useState)(checkPropsForPromo()),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    promoExpired = _useState10[0],
    setPromoExpired = _useState10[1];
  var detectQueryString = function detectQueryString(link) {
    var pattern = new RegExp(/\?.+=.*/g);
    return pattern.test(link);
  };
  var createParams = function createParams(qparams) {
    if (!qparams || JSON.stringify(qparams) === JSON.stringify({})) {
      return;
    }
    var newQParams = ''; // eslint-disable-next-line no-restricted-syntax

    for (var key in qparams) {
      // eslint-disable-next-line no-prototype-builtins
      if (qparams.hasOwnProperty(key)) {
        newQParams += "".concat(key, "=").concat(qparams[key], "&");
      }
    }
    newQParams = newQParams.substring(0, newQParams.length - 1); // eslint-disable-next-line consistent-return

    return newQParams;
  };
  var formatDate = function formatDate(dates) {
    var d = new Date(dates);
    var month = "".concat(d.getMonth() + 1);
    var day = "".concat(d.getDate());
    var year = d.getFullYear();
    if (month.length < 2) month = "0".concat(month);
    if (day.length < 2) day = "0".concat(day);
    return [year, month, day].join('-');
  };
  var formatHref = function formatHref(link, qparams) {
    if (link && (link.includes('{{startDate}}') || link.includes('{{endDate}}'))) {
      var currentDate = new Date(); // Now

      var startDate = formatDate(currentDate.setDate(currentDate.getDate() + 31));
      var endDate = formatDate(currentDate.setDate(currentDate.getDate() + 2));
      return link.replace('{{startDate}}', "\"".concat(startDate, "\"")).replace('{{endDate}}', "\"".concat(endDate, "\""));
    }
    if (!qparams || JSON.stringify(qparams) === JSON.stringify({})) {
      return link;
    }
    var formattedHref = "".concat(link);
    if (!detectQueryString(formattedHref)) {
      formattedHref += '?';
    } else {
      formattedHref += '&';
    }
    formattedHref += createParams(qparams);
    return formattedHref;
  };
  var formattedUrl = formatHref(url, queryParams);
  function multilLobCarouselClickHandler() {
    return _multilLobCarouselClickHandler.apply(this, arguments);
  }
  function _multilLobCarouselClickHandler() {
    _multilLobCarouselClickHandler = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var rs, curr, language, _rs$, origin, destination, destinationStationName, tripType, dates, passengers, promoCode, unformattedDates;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              rs = _utilities.default.getCookie(_constant5.COOKIE_NAME.FLIGHT_RECENT_SEARCHES);
              curr = _utilities.default.getCookie(_constant5.COOKIE_NAME.UHF_CURRENCY);
              language = _utilities.default.getCookie(_constant5.COOKIE_NAME.UHF_LOCALE);
              rs = decodeURIComponent(rs);
              rs = JSON.parse(rs);
              rs = (0, _utils.returnFlightSearchArray)(rs);
              if (!rs[0]) {
                _context.next = 16;
                break;
              }
              _rs$ = rs[0], origin = _rs$.origin, destination = _rs$.destination, destinationStationName = _rs$.destinationStationName, tripType = _rs$.tripType, dates = _rs$.dates, passengers = _rs$.passengers, promoCode = _rs$.promoCode, unformattedDates = _rs$.unformattedDates;
              _context.t0 = productID;
              _context.next = _context.t0 === _constant5.MULTI_LOB_ID.FLIGHTS ? 11 : _context.t0 === _constant5.MULTI_LOB_ID.HOTEL ? 12 : _context.t0 === _constant5.MULTI_LOB_ID.SNAP ? 13 : _context.t0 === _constant5.MULTI_LOB_ID.ACTIVITIES ? 14 : 15;
              break;
            case 11:
              return _context.abrupt("return", (0, _utils.flightsDeeplink)(origin, destination, dates, tripType, passengers, promoCode, language, curr, environment));
            case 12:
              return _context.abrupt("return", (0, _utils.hotelDeeplink)(url, destinationStationName, passengers.adult, passengers.child, unformattedDates, language, curr, environment));
            case 13:
              return _context.abrupt("return", (0, _utils.snapDeeplinkURL)(url, origin.StationCode, destination.StationCode, language, curr, unformattedDates, passengers.adult));
            case 14:
              return _context.abrupt("return", (0, _utils.activitiesDeeplink)(url, destination.StationCode));
            case 15:
              return _context.abrupt("return", formattedUrl);
            case 16:
              return _context.abrupt("return", formattedUrl);
            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _multilLobCarouselClickHandler.apply(this, arguments);
  }
  function handleOnClick(_x) {
    return _handleOnClick.apply(this, arguments);
  }
  function _handleOnClick() {
    _handleOnClick = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(e) {
      var listOfMultiLobs;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // GTM event should be fired in all use cases
              fireGtmHandler();
              setGtmId('carouselcard');
              if (!((cnDisclaimerLine1 || cndisclaimerLine1) && isCnDomain)) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", chinaDisclaimerListener && chinaDisclaimerListener(data));
            case 4:
              if (!(!handleClick && subtitleExpandCtaText)) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", false);
            case 6:
              listOfMultiLobs = Object.values(_constant5.MULTI_LOB_ID);
              if (!listOfMultiLobs.includes(productID)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 10;
              return multilLobCarouselClickHandler();
            case 10:
              formattedUrl = _context2.sent;
            case 11:
              if (!(!handleClick && url)) {
                _context2.next = 15;
                break;
              }
              if (!(e.target && e.target.getAttribute('id') === 'cta_link')) {
                _context2.next = 14;
                break;
              }
              return _context2.abrupt("return", null);
            case 14:
              return _context2.abrupt("return", newTab === 'TRUE' || newTab === '' ? window.open(formattedUrl, '_blank') : window.open(formattedUrl, '_self'));
            case 15:
              return _context2.abrupt("return", handleClick && handleClick(e, index, url));
            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _handleOnClick.apply(this, arguments);
  }
  var timerEndHandler = function timerEndHandler() {
    setPromoExpired(true);
    if (handleCardVisibility) {
      handleCardVisibility(index, false);
    }
  };
  var tabIndex = !accessible ? '-1' : '0';
  var dataExists = data && Object.keys(data).length !== 0;
  var isEmpty = data && Object.values(data).every(function (x) {
    return x === null || x === '';
  });
  var intIndex = parseInt(index);
  var intColSpan = parseInt(columnSpan);
  var gridCol = intIndex * intColSpan;
  gridCol += 1;
  (0, _react.useEffect)(function () {
    if (dataExists && !isEmpty && !promoExpired && isIE) {
      setCardOffsetWidth(cardWidth);
      setCardOffsetHeight(containerWrapperRef.current.offsetHeight);
    }
  }, [cardWidth, dataExists, isEmpty, isIE, promoExpired]);
  var accessibilityCurrency = function accessibilityCurrency(curr) {
    if (!curr) {
      return '';
    }
    var currencyChars = curr.split('');
    var formattedCurrencyString = '';
    currencyChars.forEach(function (e) {
      formattedCurrencyString += "".concat(e, " ");
    });
    return formattedCurrencyString;
  };
  var onMouseOverHandler = function onMouseOverHandler(e) {
    if (onMouseEnterEvent && typeof onMouseEnterEvent === 'function') {
      onMouseEnterEvent(e, index);
    }
  };
  return dataExists && !isEmpty && !promoExpired ? /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ContainerWrapper, (0, _extends2.default)({
    ref: containerWrapperRef,
    isIE: isIE,
    columnSpan: columnSpan,
    width: width,
    focusEffect: focusEffect,
    gridCol: gridCol
  }, customProperties), /*#__PURE__*/_react.default.createElement(StyledContainer, {
    hoverEffect: hoverEffect,
    isIE: isIE,
    cardOffsetHeight: cardOffsetHeight,
    cardOffsetWidth: cardOffsetWidth,
    hideBorder: hideBorder,
    isHolidaysCard: isHolidaysCard
  }, /*#__PURE__*/_react.default.createElement(CarouselCardWrapper, {
    onMouseEnter: onMouseOverHandler,
    id: dynamicID,
    tabIndex: tabIndex,
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, function () {
        return handleOnClick(e);
      }, _constant3.KEY_CODE.ENTER);
    },
    onClick: function onClick(e) {
      return handleOnClick(e);
    },
    color: color,
    role: "link",
    "aria-label": "".concat(title, " ").concat(subtitle, " at ").concat(price, " ").concat(accessibilityCurrency(currencyCode)),
    isHolidaysCard: isHolidaysCard
  }, additionalText && /*#__PURE__*/_react.default.createElement(AdditionalTag, {
    additionalTextColor: additionalTextColor,
    leftPos: leftPos,
    topPos: topPos
  }, additionalText), /*#__PURE__*/_react.default.createElement(CardHeader, {
    imageUrl: image,
    imageAlt: imageAlt,
    primaryLabel: primaryLabel,
    secondaryLabel: secondaryLabel,
    imageHoverAnimation: imageHoverAnimation,
    cardHeaderHeight: cardHeaderHeight,
    theme: theme,
    lazyLoadImage: lazyLoadImage,
    lowResolutionImageUrl: lowResolutionImageUrl,
    enableProgressiveImageLoading: enableProgressiveImageLoading,
    updateGtmId: setGtmId,
    overlayLabel: overlayLabel,
    showOverlayBackGround: showOverlayBackGround,
    customCardHeaderHeight: customCardHeaderHeight,
    imageList: imageList,
    viewPort: viewPort
  }), !isHideFooter && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CardBody, {
    attractText: attractText,
    title: title,
    subTitle: subtitle,
    stars: star,
    location: location,
    theme: theme,
    isIE: isIE,
    viewPort: viewPort,
    customSubTitleMobileSize: customSubTitleMobileSize,
    customTitleMobileSize: customTitleMobileSize,
    timerDetails: {
      timerEndDateTime: timerEndDateTime,
      timerLabelEndDays: timerLabelEndDays,
      timerLabelEndHours: timerLabelEndHours,
      timerLabelStartDays: timerLabelStartDays,
      timerLabelStartHours: timerLabelStartHours,
      timerStartDateTime: timerStartDateTime,
      timerTimeZone: timerTimeZone
    },
    timerEndHandler: timerEndHandler,
    allowLocaleFormat: allowLocaleFormat,
    locale: locale,
    localeConfig: localeConfig,
    isMobile: isMobile,
    promotionTnC: promotionTnC,
    promotionCouponCode: promotionCouponCode,
    couponBoxAlignment: couponBoxAlignment,
    couponBoxLabel: couponBoxLabel,
    couponBoxCtaText: couponBoxCtaText,
    couponBoxCtaHref: couponBoxCtaHref,
    subtitleExpandCtaText: subtitleExpandCtaText,
    tags: tags,
    updateGtmId: setGtmId,
    isHolidaysCard: isHolidaysCard,
    promotionTnCListType: promotionTnCListType,
    removeIndentation: removeIndentation
  }), /*#__PURE__*/_react.default.createElement(CardFooter, {
    location: location,
    rating: rating,
    cta: cta,
    ctaConfig: ctaConfig,
    newTab: newTab,
    priceDisclaimer: priceDisclaimer,
    discount: discount,
    originalPrice: originalprice,
    price: price,
    priceClarification: priceClarification,
    url: url,
    queryParams: queryParams,
    currencyCode: currencyCode,
    theme: theme,
    isIE: isIE,
    productType: productType,
    color: colorButton,
    hoverColor: hoverColor,
    backgroundColor: backgroundColor,
    hoverBackgroundColor: hoverBackgroundColor,
    width: widthButton,
    customProperties: customPropertiesButton,
    handleClickOnButton: handleClickOnButton // eslint-disable-next-line radix
    ,

    cardIndex: parseInt(index),
    showFormattedPrice: showFormattedPrice,
    formattedPrice: formattedPrice,
    formattedOriginalPrice: formattedOriginalPrice,
    locale: locale,
    allowLocaleFormat: allowLocaleFormat,
    isMobile: isMobile,
    decimalType: decimalType,
    updateGtmId: setGtmId,
    fireGtmHandle: fireGtmHandler,
    gaID: gaID,
    isHolidaysCard: isHolidaysCard,
    pricePrefix: pricePrefix
  })))))) : null;
};
CarouselCard.propTypes = _carouselCard.CarouselCardPropTypes.PropTypes;
CarouselCard.defaultProps = _carouselCard.CarouselCardPropTypes.DefaultProps;
CardHeader.propTypes = _carouselCard.CardHeaderPropTypes.PropTypes;
CardHeader.defaultProps = _carouselCard.CardHeaderPropTypes.DefaultProps;
CardBody.propTypes = _carouselCard.CardBodyPropTypes.PropTypes;
CardFooter.propTypes = _carouselCard.CardFooterPropTypes.PropTypes;
PromotionSubtitle.propTypes = _carouselCard.PromotionSubtitlePropTypes.PropTypes;
var _default = CarouselCard;
exports.default = _default;